import type { ReactNode } from "react";
import { Collapse, Grid, collapseClasses } from "@mui/material";
import { SearchInput, SearchResults } from "components/Search/";
import TitleImage from "assets/titre-collectivites-minified.svg";
import { useSearch } from "providers";
import { SearchCategories } from "components/Search/SearchCategories";

function MainSearch(): ReactNode {
  const { searchString } = useSearch();

  return (
    <Grid container>
      <Collapse
        in={searchString.length <= 1}
        sx={{ [`&.${collapseClasses.root}`]: { width: "100%" } }}>
        <Grid container size={12} sx={{ justifyContent: "center" }}>
          <Grid container sx={{ m: 5 }} size={{ xs: 11, sm: 8, md: 6 }}>
            <img src={TitleImage} alt="Collectivités" width="100%" height="100%" />
          </Grid>
        </Grid>
      </Collapse>
      <Grid container size={12} sx={{ justifyContent: "center" }}>
        <Grid container rowSpacing={2} size={{ xs: 12 }} sx={{ justifyContent: "center" }}>
          <Grid
            container
            sx={{ position: "sticky", zIndex: 2, top: "64px", background: "white", pb: 1, pt: 1 }}
            size={12}>
            <SearchInput size={12} autoFocus />
            <SearchCategories size={12} />
          </Grid>
          <SearchResults size={12} />
        </Grid>
      </Grid>
    </Grid>
  );
}

export default MainSearch;
